<template>
    <div>
        <div class="col-md-12">
            <div class="row" style="margin-top:20px">
                <div class="col-md-6">
                    <h3 class="page-header">
                        <i class="fa fa fa-user animated bounceInDown show-info"></i>
                        Points Detail
                    </h3>
                </div>
                <div class="col-md-6 text-end">
                    <button class="btn btn-primary" @click="backBtn()">Back</button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-3">
                            <label for="fromdate">From Date :</label>
                            <input type="date" class="form-control" id="fromdate" v-model="fromdate">
                        </div>
                        <div class="col-md-3">
                            <label for="todate">From Date :</label>
                            <input type="date" class="form-control" id="todate" v-model="todate">
                        </div>
                        <div class="col-md-3 on_bottom">
                            <button class="btn btn-primary" @click="refresh()"> Fetch Data</button>
                        </div> 
                    </div>
                </div>

            </div>
        </div>
        <div class="">
            <div class="panel">
                <div class="panel-body" style="background: none;">
                    <div>
                        <table class="table table-bordered table-hover table-striped display" id="tblmanual">
                            <thead class="table-font" style="background: #475c78;color: #fff;">
                                <th class="visible-lg">#</th>
                                <th>Type</th>
                                <th>Last Transaction</th>
                                <th>Through</th>
                                <th>Amount</th>
                                <th>Balance</th>
                            </thead>
                            <tbody class="table-font">
                                <tr v-for="(item, index) in ledgerDetails" :key="item.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        {{ item.inout==1 ? 'Points In' : 'Points Out' }}
                                    </td>
                                    <td>{{ item.transactiondate ?? '' }}</td>
                                    <td>{{ item.trantype == 37 ? 'Manually Enter' : 'Transaction' }}</td>
                                    <td>{{ item.amount ?? 0 }}</td>
                                    <td>{{ item.balance ?? 0 }}</td>
                                   
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import axios from 'axios'
import Constants from '../../components/utilities/Constants.vue';
export default {
    mixins: [Constants],
    props: ['customerid'],
   
    data() {
        return {
            currentpage: 1,
            noofrec: 10,
            ledgerDetails: [],
            userdetail: {},
            fromdate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().slice(0, 10),
			todate: new Date().toISOString().slice(0, 10),
            
            moment: moment,
        }
    },
    computed: {
        // ...mapGetters(['selectedstoreid']),
        // noofpages() {
        //     return Math.ceil(parseInt(this.rowcount) / parseInt(this.noofrec))
        // }
    },

    mounted() {
        // this.userid = this.$route.params.id
        this.refresh();
    },
    methods: {
       
        refresh() {
            let param = { customerid: this.customerid,fromdate:this.fromdate, todate :this.todate };
            axios.post('api/points/customer/ledgers', param)
                .then(response => this.processResponseLedgerDetail(response.data))
                .catch(error => console.log(error))
        },
        processResponseLedgerDetail(data){
            console.log(data)
            if(data.ledger !=null){
                this.ledgerDetails = data.ledger
                this.userdetail =  data.customer
            }
            
        },
        backBtn(){
            this.$parent.viewno = 0
        }
    }
}
</script>

<style scoped>
.btn-primary:hover {
    text-decoration: none !important;
    background-color: #3a476b !important;
}
</style>